import React from "react";
import ArchiveIcon from "../../../Assets/archivemain.svg";
import LeftArrow from "../../../Assets/leftArrow.svg";
import { Button, Tooltip } from "antd";

const ArchiveCandidates =({ onClick = () => {}, isArchiveView = false })=>{
    return (
        <div
         
        >
         <Tooltip title={isArchiveView ? "Back to Mobilisation Management" : undefined}>
         <Button
          onClick={onClick}
 
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            background: isArchiveView ? "#091E69" : "rgb(9, 30, 105)",
            border: isArchiveView ? "3px solid #F9CF66" : "3px solid rgb(249, 207, 102)",
            borderRadius: "8px",
            padding: "20px 12px",
            fontSize: "14px",
            fontWeight: "500",
            color: isArchiveView ? "#FFFFFF" : "#FFFFFF",
            cursor: "pointer",
            boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: isArchiveView ? "22px" : "28px",
              height: isArchiveView ? "22px" : "28px",
              background: isArchiveView ? "#EEF4FF" : "#FFFFFF",
              borderRadius: "6px",
            
            }}
          >
          <img src={isArchiveView ? LeftArrow : ArchiveIcon} style={{ width: isArchiveView ? 12 : 16, height: isArchiveView ? 12 : 16 }} />
          </div>
         {isArchiveView ? "Back to Mob. Mgmt" : "Archive List"}
        </Button>
        </Tooltip>
         
        </div>
    )
}

export default ArchiveCandidates;